module.exports = __webpack_public_path__ + "img/spektrum_woche.8daecb92.png";